// extracted by mini-css-extract-plugin
module.exports = {"box":"_1aQRnd0AwIrT7AZ01NjRjq","header":"_3h1r9CI_JEYvEhyyaeCKCN","headerStyle":"q_4q6CVdGGzMzmbzXOHf-","contentPaddingAuto":"PfsnRjW6SFuKFPLlIVXkD"};